export default __webpack_public_path__ + "static/okiem-stratega-8efb98e1b6036ffbc36172f364590364.webp";